import { useEffect, useState } from 'react';
import { Grid, FormGroup, FormControlLabel, Checkbox } from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import { useForm } from "react-hook-form";
import { Actions } from '../Modal'
import { Form, Input, MenuSelect, Submit, SelectAutoComplete } from '../Form'
import { createEvent, editEvent } from "../../features/events/eventsSlice";

const properties = {  id: '',  nombre: '', clave: '', responsable: '', idTipo: '', tipo: '', fecha: '', hora: '', idLugar: '', lugar: '', otroLugar: '', duracion: '', isActive: '', constancy: '', idSede: '', sede: '', idOds: '', ods: '', idModalidad: '', modalidad: '', idTematica: '', tematica: '', idArea: '', area: '' }

export default function Forms({ isRoot }){
    const [checked, setCheked] = useState(false)
    const { id, openModalEdit } = useSelector(state => state.modal);
    const dispatch = useDispatch();
    const methods = useForm({ shouldUnregister: true })
    const { areas } = useSelector(state => state.areas)
    const { events } = useSelector(state => state.events)
    const { campus } = useSelector(state => state.campus);
    const { places } = useSelector(state => state.places)
    const { types } = useSelector(state => state.types)
    const { ods } = useSelector(state => state.ods)
    const { modalities } = useSelector(state => state.modalities)
    const { thematics } = useSelector(state => state.thematics);
    const data = openModalEdit ? events.find(el => el.id === id) : properties;

    const setArea = () => {
        if(openModalEdit){
            methods.setValue('idArea', data.idArea);
        }
        return data.idArea;
    }
    
    const onSubmit = values => openModalEdit ? dispatch(editEvent({ id, values, setError: methods.setError })) : dispatch(createEvent({ values, setError: methods.setError }))
    useEffect(() => {
        if(openModalEdit){
            if(data.otroLugar) setCheked(true)
            else setCheked(false)
        }
    },[openModalEdit, data?.otroLugar])
    return(
        <Actions title={openModalEdit ? 'Editar' : 'Crear Evento'}>
            <Form methods={methods} onSubmit={onSubmit}>
                <Grid container spacing={2}>
                    { isRoot ? <SelectAutoComplete name={'idArea'} label={'Área'} options={areas} val={ setArea() } /> : null }
                    <Input name={'nombre'} label='Nombre' regEx={''} val={ data.nombre }/>
                    <Input name={'responsable'} label="Ponente o Responsable" val={ data.responsable }/>
                    <Input type="date" name={'fecha'} label="Fecha" regEx={''} size={4} val={ data.fecha } />
                    <Input type="time" name={'hora'} label="Hora" regEx={''} size={4} val={ data.hora }/>
                    <Input type="text" name={"duracion"} label="Duración" regEx={/[0-9.]/ig} min={1} max={4} size={4} val={ data.duracion }/>
                    <MenuSelect name={'tipo'} label="Tipo" options={types} size={6} val={data.idTipo} />
                    <MenuSelect name={'sede'} label={'Sede'} options={campus} size={6} val={data.idSede} />
                    <MenuSelect name={'idOds'} label={'ODS'} options={ods} size={6} val={ data.idOds } />
                    <MenuSelect name={'idModalidad'} label={'Modalidad'} options={modalities} size={6} val={ data.idTematica } />
                    <MenuSelect name={'idTematica'} label={'Temática'} options={thematics} val={ data.idModalidad } />
                    { checked
                        ? <Input name={'otroLugar'} label='Otro lugar' val={data.otroLugar} /> 
                        : <MenuSelect name={'lugar'} label="Lugar" options={places} val={ data.idLugar } /> 
                    }                    
                    <Grid item xs={12} sm={12}>
                        <FormGroup>
                            <FormControlLabel 
                                control={ <Checkbox checked={checked} onChange={() => setCheked(!checked)}  inputProps={{ 'aria-label': 'controlled'}}  />} 
                                label={ checked ? 'Desmarca para mostrar lugares' : 'Marca la casilla para agregar otro lugar' }
                            />
                        </FormGroup>
                    </Grid>
                    <Submit title={ openModalEdit ? 'Guardar cambios' : 'Registrar' } />
                </Grid>
            </Form>
        </Actions>
    )
}